import Vue from 'vue'

const state = {
  lista: [],
  area: []
}

const mutations = {
  setAreas (state, data) {
    state.lista = data
  },
  setArea (state, data) {
    state.area = data
  }
}

const getters = {
  getNomeArea: (state) => (id) => {
    let result = state.lista.find(item => item.id === id)
    return result.titulo
  },
  // getListaCombo: state => {
  //   return state.lista
  // }
}

const actions = {
  getAreas (context) {
    Vue.http.get('api/areas').then(response => {
      context.commit('setAreas', response.body.data.data)
    })
  },
  getAreasAtivas (context) {
    Vue.http.get('api/areas?status='+1).then(response => {
      context.commit('setAreas', response.body.data.data)
    })
  },
  getArea (context, id) {
    Vue.http.get('api/areas/' + id).then(response => {
      context.commit('setArea', response.body.data)
    })
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/vuex/modules/area.js